var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('header', {
    ref: "headBox",
    staticClass: "headerBox",
    class: {
      hide: _vm.State.fullScreen || _vm.State.isWebFullScreen
    }
  }, [_vm.config.urlInfo && _vm.config.urlInfo.userAuthUrl ? _c('tvu-top-header', {
    attrs: {
      "tvuLogo": false,
      "globalFunList": _vm.returnGlobalFunList,
      "multiAccountList": _vm.multiAccountList,
      "userAuthUrl": _vm.config.urlInfo && _vm.config.urlInfo.userAuthUrl,
      "theme": "dark",
      "versionServiceNameList": _vm.serviceNameList,
      "serviceVesion": [{
        serviceName: 'Partyline',
        frontendVersion: _vm.fontVersion,
        backendVersion: _vm.backendVersion,
        tagName: _vm.applicationName
      }]
    },
    on: {
      "callback": _vm.topHeaderCallback
    },
    scopedSlots: _vm._u([{
      key: "top-header-project-name",
      fn: function () {
        return [_vm.$route.name != 'intercom' && (_vm.$route.name == 'kiosk' || _vm.$route.name == 'coordinator' || _vm.$route.name == 'party' || _vm.$route.name == 'group') ? _c('div', {
          staticClass: "backHome"
        }, [_c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.$t('personalInfo.backToWorkBench'),
            "placement": "bottom"
          }
        }, [_c('i', {
          staticClass: "iconfont icon-backHome pointer",
          on: {
            "click": function ($event) {
              return _vm.gobackWorkBench();
            }
          }
        })])], 1) : _vm._e(), _vm.$route.name != 'intercom' && (_vm.$route.name == 'kiosk' || _vm.$route.name == 'coordinator' || _vm.$route.name == 'party' || _vm.$route.name == 'group') ? _c('div', {
          staticClass: "onlinePartyList"
        }, [_c('div', {
          staticClass: "partylist",
          on: {
            "click": function ($event) {
              return _vm.openPartylist('init');
            }
          }
        }, [_c('el-popover', {
          attrs: {
            "placement": "bottom",
            "width": "266",
            "trigger": "click",
            "popper-class": "onlinePartyList"
          }
        }, [_c('i', {
          staticClass: "iconfont icon-subMenu pointer",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }), _c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.$t('common.onlineComParty')))]), _c('div', {
          directives: [{
            name: "scroll",
            rawName: "v-scroll",
            value: _vm.scroll,
            expression: "scroll"
          }, {
            name: "loading",
            rawName: "v-loading",
            value: _vm.partyListLoading,
            expression: "partyListLoading"
          }],
          staticClass: "lsitContent"
        }, _vm._l(_vm.onlinePartyList, function (item) {
          return _c('div', {
            key: item.label,
            staticClass: "listParty",
            style: {
              background: _vm.getCurrentParty(item)
            },
            on: {
              "click": function ($event) {
                $event.preventDefault();
                return _vm.openPreviewPage(item);
              }
            }
          }, [_c('a', {
            staticClass: "pointer"
          }, [_vm._v(_vm._s(_vm.showTitle(item)))])]);
        }), 0)])], 1), _c('span', {
          staticClass: "border"
        })]) : _vm._e(), _c('div', {
          staticClass: "updateLogo",
          class: {
            host: _vm.isHost && (_vm.$route.name.includes('kiosk') || _vm.$route.name.includes('coordinator') || _vm.$route.name.includes('reporter'))
          },
          style: {
            width: _vm.$route.name == 'interview' ? '500px' : '168px'
          }
        }, [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.useIconFontLogoInKiosk && _vm.$route.name != 'intercom' && _vm.$route.name != 'station',
            expression: "useIconFontLogoInKiosk && $route.name != 'intercom'&& $route.name != 'station'"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "placement": "bottom"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('div', {
          class: _vm.role ? 'PlVersion' : ''
        }, [_vm._v("Partyline (ENV: " + _vm._s(_vm.applicationName) + "):"), _c('br'), _vm._v("Frontend: " + _vm._s(_vm.fontVersion)), _c('br'), _vm._v("Backend: " + _vm._s(_vm.backendVersion))]), _vm.role ? _c('div', {
          staticClass: "ProducerVersion"
        }, [_vm._v("Producer (ENV: " + _vm._s(_vm.ProducerTagName) + "):"), _c('br'), _vm._v("Frontend: " + _vm._s(_vm.ProducerFrontendVersion)), _c('br'), _vm._v("Backend: " + _vm._s(_vm.ProducerBackendVersion))]) : _vm._e()]), _c('div', {
          staticClass: "logoContent"
        }, [_c('svg', {
          staticClass: "logoSvg",
          attrs: {
            "aria-hidden": "true"
          }
        }, [_c('use', {
          attrs: {
            "xlink:href": _vm.logoSvg
          }
        })]), _c('span', {
          staticClass: "logoText"
        }, [_vm._v(_vm._s(_vm.State.logoTitle) + _vm._s(_vm.$route.name == 'interview' ? ' / Interview mode' : ''))])])]), _c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.useIconFontLogoInKiosk && _vm.$route.name != 'intercom' && _vm.$route.name != 'station',
            expression: "!useIconFontLogoInKiosk && $route.name != 'intercom'&& $route.name != 'station'"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "placement": "bottom"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('div', {
          class: _vm.role ? 'PlVersion' : ''
        }, [_vm._v("Partyline (ENV: " + _vm._s(_vm.applicationName) + "):"), _c('br'), _vm._v("Frontend: " + _vm._s(_vm.fontVersion)), _c('br'), _vm._v("Backend: " + _vm._s(_vm.backendVersion))]), _vm.role ? _c('div', {
          staticClass: "ProducerVersion"
        }, [_vm._v("Producer (ENV: " + _vm._s(_vm.ProducerTagName) + "):"), _c('br'), _vm._v("Frontend: " + _vm._s(_vm.ProducerFrontendVersion)), _c('br'), _vm._v("Backend: " + _vm._s(_vm.ProducerBackendVersion))]) : _vm._e()]), _c('img', {
          attrs: {
            "src": _vm.logos
          }
        })]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.$route.name == 'intercom' || _vm.$route.name == 'station',
            expression: "$route.name == 'intercom' || $route.name == 'station'"
          }],
          staticClass: "logoContent"
        }, [_c('svg', {
          staticClass: "logoSvg",
          attrs: {
            "aria-hidden": "true"
          }
        }, [_c('use', {
          attrs: {
            "xlink:href": _vm.logoSvg
          }
        })]), _c('span', {
          staticClass: "logoText"
        }, [_vm._v(_vm._s(_vm.$t('intercom.intercom')))])]), (_vm.$route.name.includes('kiosk') || _vm.$route.name.includes('coordinator') || _vm.$route.name.includes('reporter')) && _vm.isHost ? _c('span', {
          staticClass: "selectText pointer",
          on: {
            "click": _vm.showUploadLogo
          }
        }, [_vm._v(_vm._s(_vm.$t('kioskHost.selectImg')))]) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "account-center-module",
      fn: function () {
        return [_c('div', {
          staticClass: "contaniner login-info"
        }, [_vm.$route.name != 'globalControl' && _vm.$route.name != 'intercom' ? _c('div', {
          staticClass: "collaborate commonLi",
          on: {
            "click": _vm.showCollaborate
          }
        }, [_c('div', {
          staticClass: "left"
        }, [_vm._v(" " + _vm._s(_vm.$t("personalInfo.collaborate")) + " "), _c('span', {
          staticClass: "info"
        }, [_c('el-tooltip', {
          attrs: {
            "popper-class": "collaborate",
            "placement": "bottom",
            "visible-arrow": false
          }
        }, [_c('i', {
          staticClass: "iconfont icon-help2"
        }), _c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('div', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.addEmailTile")))]), _c('p', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.liveWithAccount")))]), _c('p', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.moveAccount")))]), _c('p', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.pullAccount")))])])])], 1)]), _c('div', {
          staticClass: "right"
        }, _vm._l(_vm.hadInvite, function (item, index) {
          return _c('span', {
            key: index,
            staticClass: "invitedPerson",
            class: _vm.userBgColor(item.email),
            attrs: {
              "title": item.email
            }
          }, [_vm._v(_vm._s(item.label))]);
        }), 0)]) : _vm._e(), _vm.$route.name == 'party' ? _c('div', {
          staticClass: "enterReceivedCohost commonLi",
          on: {
            "click": _vm.showReceivedPop
          }
        }, [_c('div', [_c('div', {
          staticStyle: {
            "display": "inline"
          }
        }, [_vm._v(_vm._s(_vm.$t('personalInfo.receivedCohost')))]), _c('span', {
          staticClass: "info"
        }, [_c('el-tooltip', {
          attrs: {
            "popper-class": "collaborate",
            "placement": "bottom",
            "visible-arrow": false
          }
        }, [_c('i', {
          staticClass: "iconfont icon-help2",
          staticStyle: {
            "color": "#6D6D6D"
          }
        }), _c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('p', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.receivedCohostTextOne")))]), _c('p', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.receivedCohostTextSecond")))])])])], 1)])]) : _vm._e(), _vm.$route.name != 'intercom' ? _c('div', {
          staticClass: "usageService commonLi"
        }, [_c('a', {
          attrs: {
            "href": _vm.openUsagePage,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('common.usageService')))])]) : _vm._e(), _vm.$cm.switchLang ? _c('div', {
          staticClass: "language commonLi"
        }, [_c('div', {
          staticClass: "left"
        }, [_vm._v(" " + _vm._s(_vm.$t('personalInfo.lang')) + " ")]), _c('div', {
          staticClass: "right"
        }, [_c('span', {
          class: {
            active: _vm.$i18n.locale === 'en'
          },
          on: {
            "click": function ($event) {
              return _vm.changeLanguage('en');
            }
          }
        }, [_vm._v("EN")]), _c('span', {
          staticClass: "second"
        }, [_vm._v("/")]), _c('span', {
          class: {
            active: _vm.$i18n.locale === 'zh'
          },
          on: {
            "click": function ($event) {
              return _vm.changeLanguage('zh');
            }
          }
        }, [_vm._v("中文")])])]) : _vm._e()])];
      },
      proxy: true
    }, {
      key: "top-header-middle",
      fn: function () {
        return [_c('div', {
          staticClass: "centerSeciotn"
        }, [_c('el-popover', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.$route.name != 'globalControl',
            expression: "$route.name != 'globalControl'"
          }],
          attrs: {
            "popper-class": "netWorkTips",
            "effect": "dark",
            "placement": "bottom-start",
            "visible-arrow": false
          }
        }, [_c('div', [_c('h6', [_vm._v(_vm._s(_vm.$t('addWords.bandWidth')))]), _c('p', {
          staticClass: "upLink"
        }, [_c('i', {
          staticClass: "el-icon-top",
          class: _vm.colorUp
        }), _c('span', {
          class: _vm.colorUp
        }, [_vm._v(_vm._s(_vm.$t(`netWorkStatus.${_vm.netWork.upLinkNetWork}`)))])]), _c('p', {
          staticClass: "downLink"
        }, [_c('i', {
          staticClass: "el-icon-bottom",
          class: _vm.colorDown
        }), _c('span', {
          class: _vm.colorDown
        }, [_vm._v(_vm._s(_vm.$t(`netWorkStatus.${_vm.netWork.downLinkNetWork}`)))])]), _vm.$route.name != 'intercom' && _vm.$route.name != 'station' ? _c('div', {
          staticClass: "audioOnlyBox"
        }, [_c('el-divider'), _c('div', {
          staticClass: "head"
        }, [_c('span', {
          staticClass: "head-title"
        }, [_vm._v(_vm._s(_vm.$t('netWorkStatus.saveBandWIdth')))]), _c('el-tooltip', {
          attrs: {
            "popper-class": "audioOnlyHelp",
            "placement": "right-start",
            "visible-arrow": false
          }
        }, [_c('i', {
          staticClass: "iconfont icon-help2"
        }), _c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('p', {
          staticClass: "automaticTitle"
        }, [_vm._v(_vm._s(_vm.$t('netWorkStatus.AutoAudioOnly')))]), _c('ul', {
          staticClass: "automatic"
        }, [_c('li', [_vm._v("· " + _vm._s(_vm.$t('netWorkStatus.AutoAudioText')))])]), _c('p', {
          staticClass: "allTimeTile"
        }, [_vm._v(_vm._s(_vm.$t('netWorkStatus.AllTimeAudioOnly')))]), _c('ul', {
          staticClass: "allTime"
        }, [_c('li', [_vm._v("· " + _vm._s(_vm.$t('netWorkStatus.AllTimeAudioText')))])]), _c('p', {
          staticClass: "disableAodiuOnly"
        }, [_vm._v(_vm._s(_vm.$t('netWorkStatus.AudioDisabled')))]), _c('ul', {
          staticClass: "disableAudio"
        }, [_c('li', [_vm._v("· " + _vm._s(_vm.$t('netWorkStatus.AudioOnlyDisabledText')))])])])])], 1), _c('el-select', {
          on: {
            "change": _vm.controlAudioOnly
          },
          model: {
            value: _vm.audioType,
            callback: function ($$v) {
              _vm.audioType = $$v;
            },
            expression: "audioType"
          }
        }, _vm._l(_vm.audiOnlyOperation, function (item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": _vm.$t(`netWorkStatus.${item.label}`),
              "value": item.value
            }
          });
        }), 1), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.audioType != 2 && _vm.$route.name != 'channelParticipate',
            expression: "audioType != 2 && $route.name != 'channelParticipate'"
          }],
          staticClass: "foot"
        }, [_c('p', [_vm._v(_vm._s(_vm.$t('netWorkStatus.stillWantToLoad')))]), _c('div', {
          staticClass: "footContent"
        }, [_c('div', {
          staticClass: "left"
        }, [_c('el-checkbox', {
          on: {
            "change": _vm.controlMainWindow
          },
          model: {
            value: _vm.checkMainWindow,
            callback: function ($$v) {
              _vm.checkMainWindow = $$v;
            },
            expression: "checkMainWindow"
          }
        }, [_vm._v(_vm._s(_vm.$t('netWorkStatus.pinnWindow')))]), _c('el-tooltip', {
          attrs: {
            "popper-class": "pinnTips",
            "tips": "",
            "placement": "bottom"
          }
        }, [_c('i', {
          staticClass: "iconfont icon-help2"
        }), _c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('p', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.$t("netWorkStatus.operationIncludes")))]), _c('p', {
          staticClass: "text"
        }, [_vm._v("· " + _vm._s(_vm.$t("netWorkStatus.mainwindowByHost")))]), _c('p', {
          staticClass: "text"
        }, [_vm._v("· " + _vm._s(_vm.$t("netWorkStatus.leftRightWindow")))])])])], 1), _c('div', {
          staticClass: "right"
        }, [_c('el-checkbox', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.$route.name != 'group',
            expression: "$route.name != 'group'"
          }],
          on: {
            "change": _vm.controlShareScreen
          },
          model: {
            value: _vm.checkShareScreen,
            callback: function ($$v) {
              _vm.checkShareScreen = $$v;
            },
            expression: "checkShareScreen"
          }
        }, [_vm._v(_vm._s(_vm.$t('netWorkStatus.SharedScreen')))])], 1)])])], 1) : _vm._e()]), _c('NetWorkQuality', {
          attrs: {
            "slot": "reference"
          },
          on: {
            "callback": _vm.showNetWork
          },
          slot: "reference"
        })], 1), _vm.showUrlText ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "placement": "top"
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.urlText(_vm.partyCode, _vm.isCoordinator ? 3 : 4))
          }
        })]), _c('span', {
          on: {
            "click": _vm.showEditInput
          }
        }, [_vm._v(_vm._s(_vm.urlTextInfo))])]) : _c('el-input', {
          ref: "partyInput",
          staticClass: "urlInput",
          attrs: {
            "maxlength": 32
          },
          on: {
            "blur": function ($event) {
              _vm.showUrlText = true;
            },
            "change": _vm.changePartyName
          },
          model: {
            value: _vm.inputUrlText,
            callback: function ($$v) {
              _vm.inputUrlText = $$v;
            },
            expression: "inputUrlText"
          }
        }), _vm.showCopyButton && _vm.$route.name != 'interviewParticipate' ? _c('span', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard:copy",
            value: _vm.urlAddress,
            expression: "urlAddress",
            arg: "copy"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:success",
            value: _vm.onCopy,
            expression: "onCopy",
            arg: "success"
          }, {
            name: "clipboard",
            rawName: "v-clipboard:error",
            value: _vm.onError,
            expression: "onError",
            arg: "error"
          }],
          staticClass: "copyBtn",
          class: {
            hide: _vm.isHost || _vm.State.participantRole === 1 || _vm.State.participantRole === 2
          }
        }, [_vm._v(" " + _vm._s(_vm.isHost || _vm.State.participantRole === 1 || _vm.State.participantRole === 2 ? "" : _vm.$t('commonPartyHost.topContent.copy')) + " ")]) : _vm._e(), !_vm.isHost && !_vm.State.checkEnv.coHost && _vm.showCopyButton && _vm.$route.name != 'interviewParticipate' ? _c('el-divider', {
          staticClass: "accountDivider",
          staticStyle: {
            "margin-left": "12px",
            "margin-right": "12px"
          },
          attrs: {
            "direction": "vertical"
          }
        }) : _vm._e(), !_vm.isHost && !_vm.State.checkEnv.coHost && _vm.showCopyButton && _vm.$route.name != 'interviewParticipate' ? _c('el-tooltip', {
          staticClass: "qrCode",
          attrs: {
            "effect": "dark",
            "popper-class": "qrCodeBox",
            "placement": "bottom"
          }
        }, [_c('div', {
          staticClass: "box",
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('img', {
          staticClass: "qrCodeImg",
          attrs: {
            "src": _vm.qrCodeUrl
          }
        }), _c('div', {
          staticClass: "qrCodeText"
        }, [_vm._v(_vm._s(_vm.partyJoinInfo.channelMode == 18 ? _vm.$t('common.qrCodeText1') : _vm.$t('common.qrCodeText')))])]), _c('div', {
          attrs: {
            "id": "qrCodeParticipant"
          }
        }, [_c('i', {
          staticClass: "iconfont icon-Vector1"
        })])]) : _vm._e(), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showEndBtn && _vm.$route.name != 'interview' || _vm.$route.name === 'intercom',
            expression: "(showEndBtn && $route.name != 'interview' )|| $route.name === 'intercom'"
          }],
          staticClass: "invite",
          on: {
            "click": _vm.showInvitePop
          }
        }, [_vm._v(_vm._s(_vm.$t('invite.invite')))]), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showEndBtn,
            expression: "showEndBtn"
          }],
          staticClass: "border"
        }), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showEndBtn,
            expression: "showEndBtn"
          }],
          staticClass: "endBtn",
          on: {
            "click": _vm.endCurrentParty
          }
        }, [_vm._v(_vm._s(_vm.$t('invite.inviteEndParty')))])], 1)];
      },
      proxy: true
    }, {
      key: "right-app-module",
      fn: function () {
        return [!_vm.userInfo.email && _vm.showLoginButton ? _c('div', {
          staticClass: "item-fun"
        }, [_c('el-button', {
          staticClass: "register",
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.login
          }
        }, [_vm._v(_vm._s(_vm.$t('personalInfo.login')) + "/" + _vm._s(_vm.$t('personalInfo.register')))])], 1) : _vm._e(), !_vm.partyJoinInfo.owner && _vm.$cm.switchLang && _vm.$route.name != 'intercom' ? _c('div', {
          staticClass: "item-fun"
        }, [_c('span', {
          staticClass: "translateIcon"
        }, [_c('span', {
          staticClass: "noLoginLang",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": _vm.changeParticipantLanguage
          }
        }, [_vm.$i18n.locale === 'zh' ? _c('i', {
          staticClass: "iconfont icon-a-V2chinese"
        }) : _c('i', {
          staticClass: "iconfont icon-a-V2English"
        })])])]) : _vm._e(), _vm.$route.name == 'coordinator' ? _c('div', {
          staticClass: "item-fun"
        }, [_c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.$t('common.audience'),
            "placement": "bottom"
          }
        }, [_c('div', {
          staticClass: "right audience",
          class: {
            active: _vm.showAudience
          },
          on: {
            "click": _vm.showAudienceBox
          }
        }, [_c('i', {
          staticClass: "iconfont icon-touxiang"
        })])])], 1) : _vm._e(), _vm.State.groupLayout.layoutName == '2-2' && _vm.currentPartyInfo.code && _vm.$route.name.includes('group') ? _c('div', {
          staticClass: "item-fun talkToEachOther"
        }, [_c('el-popover', {
          attrs: {
            "placement": "bottom",
            "title": "",
            "popper-class": "raisePopover",
            "width": "200",
            "trigger": "click"
          }
        }, [_c('div', [_vm._v(" " + _vm._s(_vm.$t('galleryHost.talkWithEach')) + " "), _c('el-switch', {
          attrs: {
            "disabled": _vm.disabledFreeTalk,
            "active-color": "#13ce66",
            "inactive-color": "#999"
          },
          on: {
            "change": _vm.changeFreeTalk
          },
          model: {
            value: _vm.freeTalk,
            callback: function ($$v) {
              _vm.freeTalk = $$v;
            },
            expression: "freeTalk"
          }
        })], 1), _c('div', {
          staticClass: "listenEachOther",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "el-icon-arrow-down"
        })])])], 1) : _vm._e(), _vm.$route.name.includes('group') ? _c('div', {
          staticClass: "item-fun"
        }, [_c('el-menu', {
          staticClass: "el-menu-demo",
          attrs: {
            "default-active": _vm.State.groupLayout.layoutName,
            "mode": "horizontal"
          },
          on: {
            "select": _vm.changeLayout
          }
        }, [_c('el-submenu', {
          attrs: {
            "index": "1"
          }
        }, [_c('template', {
          slot: "title"
        }, [_c('i', {
          staticClass: "iconfont icon-a-V2layout"
        })]), _vm._l(_vm.layoutConfig, function (val, key) {
          return _c('el-menu-item', {
            key: key,
            attrs: {
              "disabled": _vm.State.hadPullStream ? true : false,
              "index": key
            }
          }, [_vm._v(" " + _vm._s(val) + " ")]);
        })], 2)], 1)], 1) : _vm._e(), _vm.$route.name.includes('group') || _vm.$route.name == 'kiosk' ? _c('div', {
          staticClass: "item-fun"
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('galleryHost.fullScreen'),
            "placement": "bottom"
          }
        }, [_c('div', {
          staticClass: "chatIcon fullScreen"
        }, [_c('i', {
          staticClass: "iconfont icon-a-V2fullscreen",
          on: {
            "click": _vm.pageFullScreen
          }
        })])])], 1) : _vm._e(), _vm.partyCode.length == 16 && _vm.$route.name.includes('group') ? _c('div', {
          staticClass: "item-fun"
        }, [_vm.partyCode.length == 16 && _vm.$route.name.includes('group') ? _c('el-popover', {
          attrs: {
            "placement": "bottom",
            "width": "340",
            "popper-class": "raisePopover",
            "trigger": "click"
          },
          on: {
            "show": function ($event) {
              return _vm.initRaiseHandList();
            }
          },
          model: {
            value: _vm.showRaiseHand,
            callback: function ($$v) {
              _vm.showRaiseHand = $$v;
            },
            expression: "showRaiseHand"
          }
        }, [_c('div', {
          staticClass: "content-box"
        }, [_c('div', {
          staticClass: "content-head"
        }, [_vm._v(_vm._s(_vm.$t('galleryHost.privateChatQueue')))]), _vm.raiseHandList.length ? _c('p', [_vm._v(" " + _vm._s(_vm.$t('galleryHost.selectOneToChat')) + " ")]) : _vm._e(), _vm.raiseHandStream.id ? _c('div', {
          staticClass: "raiseVideoBox"
        }, [_c('NewAttendUser', {
          attrs: {
            "nickName": _vm.raisePrivateName,
            "tagName": _vm.tagName[_vm.State.privateInfo.rtilCode] || _vm.raisePrivateTagName,
            "singChannel": _vm.raiseHandStream,
            "userInfo": _vm.joinUserInfo,
            "notShowPraviteBg": true,
            "useOldFullScreen": true,
            "rtc": _vm.State.rtcList[_vm.raiseHandStream.channel],
            "controlMute": _vm.State.privateInfo.rtilCode ? false : '',
            "muteVideo": JSON.stringify(_vm.State.privateInfo) != '{}' ? !_vm.State.cameraStatus[_vm.State.privateInfo.rtilCode] : false,
            "muteAudio": JSON.stringify(_vm.State.privateInfo) != '{}' ? !_vm.State.micStatus[_vm.State.privateInfo.rtilCode] : false
          }
        })], 1) : _vm._e(), _c('div', {
          staticClass: "content"
        }, [_vm._l(_vm.raiseHandList, function (item, index) {
          return _c('div', {
            key: index,
            staticClass: "raiseLi"
          }, [_c('span', {
            staticClass: "name",
            class: {
              greenColor: item.talkStatus != 'talk',
              redColor: item.disabled
            },
            attrs: {
              "title": item.nickName
            }
          }, [_vm._v(" " + _vm._s(item.nickName) + _vm._s(_vm.tagName[item.rtilCode] || item.tagName ? ` / ${_vm.tagName[item.rtilCode] || item.tagName}` : '') + " ")]), !item.disabled ? _c('span', {
            staticClass: "talk cursor",
            class: {
              redColor: item.talkStatus != 'talk'
            },
            on: {
              "click": function ($event) {
                return _vm.setPrivateChat(item);
              }
            }
          }, [_vm._v(_vm._s(_vm.$t(`galleryHost.${item.talkStatus}`)))]) : _vm._e(), !item.disabled ? _c('el-divider', {
            attrs: {
              "direction": "vertical"
            }
          }) : _vm._e(), !item.disabled ? _c('span', {
            staticClass: "refuse cursor",
            class: {
              grayColor: item.talkStatus != 'talk'
            },
            on: {
              "click": function ($event) {
                return _vm.refuseConversation(item);
              }
            }
          }, [_vm._v(_vm._s(_vm.$t('galleryHost.done')))]) : _vm._e(), item.disabled ? _c('span', {
            staticClass: "pravite redColor"
          }, [_vm._v(_vm._s(_vm.$t('galleryHost.privateChannel')) + "...")]) : _vm._e()], 1);
        }), !_vm.raiseHandList.length ? _c('span', [_vm._v(_vm._s(_vm.$t('galleryHost.queueNoParti')))]) : _vm._e()], 2)]), _c('div', {
          staticClass: "right redSpotsBox pointer",
          class: {
            active: _vm.showRaiseHand
          },
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "iconfont icon-a-V2raisehand",
          class: {
            active: _vm.showRaiseHand
          }
        }), _vm.raiseHandList.length ? _c('span', {
          staticClass: "redSpots"
        }) : _vm._e()])]) : _vm._e()], 1) : _vm._e(), _vm.$route.name.includes('group') ? _c('div', {
          staticClass: "item-fun"
        }, [_c('el-popover', {
          staticClass: "right pointer replaceSpan",
          class: {
            active: _vm.showReplace
          },
          attrs: {
            "placement": "bottom",
            "popper-class": "replaceSet",
            "trigger": "click"
          },
          on: {
            "show": _vm.getReplace
          },
          model: {
            value: _vm.showReplace,
            callback: function ($$v) {
              _vm.showReplace = $$v;
            },
            expression: "showReplace"
          }
        }, [_c('div', [_c('div', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.$t('galleryHost.fillInRule')))]), _c('p', {
          staticClass: "grayColor"
        }, [_vm._v(" " + _vm._s(_vm.$t('galleryHost.rulesDes')) + " ")]), _c('div', {
          staticClass: "commonDiv"
        }, [_c('i', {
          staticClass: "iconfont icon-right pointer",
          class: {
            active: _vm.replaceIndex == 1
          },
          on: {
            "click": function ($event) {
              return _vm.setReplace(1);
            }
          }
        }), _c('span', [_vm._v(_vm._s(_vm.$t('galleryHost.autoFilled')))])]), _c('div', {
          staticClass: "commonDiv"
        }, [_c('i', {
          staticClass: "iconfont icon-right pointer",
          class: {
            active: _vm.replaceIndex == 2
          },
          on: {
            "click": function ($event) {
              return _vm.setReplace(2);
            }
          }
        }), _c('span', [_vm._v(_vm._s(_vm.$t('galleryHost.chooseWho')))])]), _c('div', {
          staticClass: "commonDiv"
        }, [_c('i', {
          staticClass: "iconfont icon-right pointer",
          class: {
            active: _vm.replaceIndex == 3
          },
          on: {
            "click": function ($event) {
              return _vm.setReplace(3);
            }
          }
        }), _c('span', [_vm._v(_vm._s(_vm.$t('galleryHost.donotRe')))])]), _c('div', {
          staticClass: "commonDiv"
        }, [_c('i', {
          staticClass: "iconfont icon-right pointer",
          class: {
            active: _vm.replaceIndex == 4
          },
          on: {
            "click": function ($event) {
              return _vm.setReplace(4);
            }
          }
        }), _c('span', [_vm._v(_vm._s(_vm.$t('galleryHost.copySLot')))])]), _vm.replaceIndex == 4 ? _c('el-select', {
          staticClass: "copySlotSelect",
          attrs: {
            "placeholder": "select position"
          },
          on: {
            "change": _vm.setCopySlot
          },
          model: {
            value: _vm.selectPosition,
            callback: function ($$v) {
              _vm.selectPosition = $$v;
            },
            expression: "selectPosition"
          }
        }, _vm._l(_vm.State.galleryAllGroupRtilCodes, function (item, index) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": `slot${index + 1}`,
              "value": index
            }
          });
        }), 1) : _vm._e()], 1), _c('i', {
          staticClass: "iconfont icon-a-V2seatrule",
          class: {
            active: _vm.showReplace
          },
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        })])], 1) : _vm._e(), _vm.$route.name.includes('coordinator') ? _c('div', {
          staticClass: "item-fun"
        }, [_c('el-tooltip', {
          attrs: {
            "placement": "bottom",
            "width": "340",
            "content": _vm.$t('galleryParticipant.applyChat')
          },
          model: {
            value: _vm.showRaiseHandTips,
            callback: function ($$v) {
              _vm.showRaiseHandTips = $$v;
            },
            expression: "showRaiseHandTips"
          }
        }, [_c('div', {
          staticClass: "right redSpotsBox pointer",
          class: {
            active: _vm.showConferenceRaise
          },
          on: {
            "click": _vm.showRaiseHandList
          }
        }, [_c('i', {
          staticClass: "iconfont icon-a-V2raisehand",
          class: {
            active: _vm.showConferenceRaise,
            unread: _vm.haveUnRead
          }
        })])])], 1) : _vm._e(), _vm.showMovePip ? _c('div', {
          staticClass: "item-fun"
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": `${_vm.State.batchMoveParticipate ? _vm.$t('Movepips.cancelOperations') : _vm.$t('Movepips.movepip')}`,
            "placement": "bottom"
          }
        }, [_c('div', {
          staticClass: "moveParticipate",
          class: {
            active: _vm.State.batchMoveParticipate
          },
          on: {
            "click": _vm.movePips
          }
        }, [_c('i', {
          staticClass: "iconfont icon-a-V2move",
          class: {
            active: _vm.State.batchMoveParticipate
          }
        })])])], 1) : _vm._e(), _vm.$route.name != 'intercom' && _vm.$route.name != 'interview' ? _c('div', {
          staticClass: "item-fun"
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('setting.settingName'),
            "placement": "bottom-start"
          }
        }, [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showParticipantSetting,
            expression: "showParticipantSetting"
          }],
          staticClass: "iconfont icon-shezhi3 right pointer",
          class: {
            active: _vm.participantAudioMatrix
          },
          on: {
            "click": _vm.controlSetting
          }
        })]), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('setting.settingName'),
            "placement": "bottom-start"
          }
        }, [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isHost || _vm.State.participantRole === 1 || _vm.State.participantRole === 2) && _vm.$route.name != 'globalControl',
            expression: "(isHost || State.participantRole === 1 || State.participantRole === 2) && $route.name != 'globalControl'"
          }],
          staticClass: "iconfont icon-shezhi3 right pointer",
          class: {
            active: _vm.settingPopupInfo.show
          },
          on: {
            "click": _vm.showSettingPopup
          }
        })])], 1) : _vm._e(), _c('div', {
          staticClass: "item-fun"
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "placement": "bottom",
            "effect": "dark",
            "content": _vm.$t('addTvuOne.add')
          }
        }, [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.isHost && (_vm.partyJoinInfo.channelMode == 0 || _vm.partyJoinInfo.channelMode == 1) || _vm.currentPartyInfo.coHost == 2 || _vm.$route.name == 'intercom',
            expression: "isHost && (partyJoinInfo.channelMode == 0 || partyJoinInfo.channelMode == 1) || currentPartyInfo.coHost == 2 || $route.name == 'intercom'"
          }],
          staticClass: "chatIcon",
          on: {
            "click": _vm.showAddDeviceBox
          }
        }, [_c('i', {
          staticClass: "iconfont icon-addDevice"
        })])])], 1), _c('div', {
          staticClass: "item-fun"
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "placement": "bottom",
            "effect": "dark",
            "content": _vm.$t('common.showUploadImage')
          }
        }, [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.isHost && _vm.partyJoinInfo.channelMode == 1,
            expression: "isHost && partyJoinInfo.channelMode == 1"
          }],
          staticClass: "uploadImageIcon",
          on: {
            "click": _vm.showUplodImageBox
          }
        }, [_c('i', {
          staticClass: "el-icon-picture-outline"
        })])])], 1)];
      },
      proxy: true
    }], null, false, 1515875197)
  }) : _vm._e(), _c('setting-dialog', {
    ref: "settingDialog",
    attrs: {
      "showSetting": _vm.settingPopupInfo.show,
      "statusInfo": _vm.partyJoinInfo.status
    },
    on: {
      "callback": _vm.closeSettingDialog
    }
  }), _c('el-dialog', {
    staticClass: "t_left",
    attrs: {
      "title": _vm.$t('conferenceParticipant.leaveParty'),
      "visible": _vm.dialogTableVisible,
      "modal": false,
      "append-to-body": true,
      "width": "442px"
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogTableVisible = $event;
      }
    }
  }, [_c('p', {
    staticClass: "diaText"
  }, [_vm._v(_vm._s(_vm.$t('conferenceParticipant.areYouOk')))]), _c('div', {
    staticClass: "diaContent t_right"
  }, [_c('el-button', {
    on: {
      "click": function ($event) {
        _vm.dialogTableVisible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('conferenceParticipant.cancel')))]), _c('el-button', {
    staticClass: "joinBtn",
    on: {
      "click": _vm.leave
    }
  }, [_vm._v(_vm._s(_vm.$t('conferenceParticipant.leave')))])], 1)]), _c('el-dialog', {
    staticClass: "uploadLogoDialog",
    attrs: {
      "title": _vm.$t('kioskHost.uploadLogo'),
      "visible": _vm.uploadLogoVisible,
      "modal": true,
      "modal-append-to-body": false,
      "width": "640px"
    },
    on: {
      "update:visible": function ($event) {
        _vm.uploadLogoVisible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "element-loading-background": "rgba(0, 0, 0, 0.7)"
    }
  }, [_c('div', {
    staticClass: "content-top"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": "image/png, image/jpeg",
      "action": "#",
      "http-request": _vm.uploadFileBySDK,
      "on-change": _vm.handleChange,
      "show-file-list": false,
      "disabled": _vm.uploadLogoLoading
    }
  }, [_c('div', {
    staticClass: "imgBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadDialogImg
    }
  })]), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.uploadLogoLoading
    }
  }, [_vm._v(_vm._s(_vm.$t('kioskHost.uploadBtnText')))])], 1)], 1), _c('div', {
    staticClass: "content-foot"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("· " + _vm._s(_vm.$t('kioskHost.displayArea')) + " : 168px * 44px")]), _c('span', {
    staticClass: "text"
  }, [_vm._v("· " + _vm._s(_vm.$t('kioskHost.imageFormat')) + " : png, jpg")]), _c('span', {
    staticClass: "text"
  }, [_vm._v("· " + _vm._s(_vm.$t('kioskHost.maxSize')))]), _c('span', {
    staticClass: "text greenColor pointer",
    on: {
      "click": _vm.useDefaultLogo
    }
  }, [_vm._v(_vm._s(_vm.$t('kioskHost.useDefaultLogo')))])])])]), _c('TipsDailog', {
    staticClass: "t_left",
    attrs: {
      "info": _vm.publicInfo
    },
    on: {
      "save": _vm.switchPrivate,
      "close": function ($event) {
        _vm.privateLoading = false;
      },
      "cancel": function ($event) {
        _vm.privateLoading = false;
      }
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('remainWords.switchPublicWords')))])]), _c('TipsDailog', {
    staticClass: "endParty",
    attrs: {
      "info": _vm.endInfo
    },
    on: {
      "save": _vm.saveEnd
    }
  }), _c('TipsDailog', {
    staticClass: "setJoinBox",
    attrs: {
      "info": _vm.showInviteInfo,
      "width": "560px"
    },
    on: {
      "save": _vm.setJoinWay,
      "open": _vm.getHadInviteUser
    }
  }, [_c('div', {
    staticClass: "controlInvite"
  }, [_c('svg', {
    staticClass: "m_r_20 icon-permission1",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-permission1"
    }
  })]), _c('el-select', {
    attrs: {
      "popper-class": "modelSelect",
      "placeholder": "please select model"
    },
    on: {
      "change": _vm.showHadInvite
    },
    model: {
      value: _vm.selectModule,
      callback: function ($$v) {
        _vm.selectModule = $$v;
      },
      expression: "selectModule"
    }
  }, _vm._l(_vm.joinModel, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm._f("showJoinModel")(item.value),
        "value": item.value
      }
    });
  }), 1), _c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.urlAddress,
      expression: "urlAddress",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: _vm.onCopy,
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: _vm.onError,
      expression: "onError",
      arg: "error"
    }],
    staticClass: "copy"
  }, [_vm._v(" " + _vm._s(_vm.$t('invite.copyLink')) + " ")]), _c('el-divider', {
    staticStyle: {
      "margin-left": "12px",
      "margin-right": "12px"
    },
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-tooltip', {
    staticClass: "qrCode",
    attrs: {
      "effect": "dark",
      "popper-class": "qrCodeBox",
      "content": "Top Left 提示文字",
      "placement": "bottom"
    }
  }, [_c('div', {
    staticClass: "box",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('img', {
    staticClass: "qrCodeImg",
    attrs: {
      "src": _vm.qrCodeUrl
    }
  }), _vm.$route.name != 'intercom' ? _c('div', {
    staticClass: "qrCodeText"
  }, [_vm._v(_vm._s(_vm.partyJoinInfo.channelMode == 18 ? _vm.$t('common.qrCodeText1') : _vm.$t('common.qrCodeText')))]) : _vm._e()]), _c('div', {
    attrs: {
      "id": "qrCode"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-Vector1"
  })])])], 1), _vm.selectModule === 1 || _vm.selectModule === 3 ? _c('el-divider', {
    staticClass: "inviteSlider"
  }) : _vm._e(), _vm.selectModule === 1 ? _c('div', {
    staticClass: "inviteBox"
  }, [_c('div', {
    staticClass: "userListBox"
  }, [_c('p', {
    staticClass: "moduleTitle"
  }, [_vm._v(_vm._s(_vm.$t('invite.shareTo')))]), _c('div', {
    staticClass: "moduleContent"
  }, [_c('svg', {
    staticClass: "m_r_20 icon-share3",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-share3"
    }
  })]), _c('el-input', {
    ref: "emailInput",
    class: {
      redBorder: _vm.showErrorEmailText
    },
    attrs: {
      "placeholder": _vm.$t('invite.invitePlaceholder'),
      "clearable": ""
    },
    on: {
      "input": _vm.checkInputText
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.addInviteList.apply(null, arguments);
      }
    },
    model: {
      value: _vm.searchName,
      callback: function ($$v) {
        _vm.searchName = $$v;
      },
      expression: "searchName"
    }
  }), _c('el-button', {
    on: {
      "click": _vm.addInviteList
    }
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.adds')))])], 1), _vm.showErrorEmailText ? _c('p', {
    staticClass: "redColor emailWarn"
  }, [_vm._v("* " + _vm._s(_vm.$t('invite.emailCorrectly')))]) : _vm._e()]), _c('div', {
    staticClass: "hadInviteList scrollbar gray"
  }, [_vm._l(_vm.willInviteList, function (user, index) {
    return _c('div', {
      key: user.name,
      staticClass: "li"
    }, [_c('span', {
      staticClass: "firstName",
      class: user.color
    }, [_vm._v(_vm._s(user.name ? user.name.slice(0, 1) : ''))]), _c('span', {
      staticClass: "emailContent"
    }, [_vm._v(_vm._s(user.name))]), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "hover",
        "popper-class": "remove"
      }
    }, [_c('i', {
      staticClass: "el-icon-more right",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.removeInvite(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])], 1);
  }), _vm.willInviteList.length ? _c('el-divider') : _vm._e(), _vm._l(_vm.hadInviteList, function (user) {
    return _c('div', {
      key: user.name,
      staticClass: "li"
    }, [_c('span', {
      staticClass: "firstName",
      class: user.color
    }, [_vm._v(_vm._s(user.name ? user.name.slice(0, 1) : ''))]), _c('span', {
      staticClass: "emailContent"
    }, [_vm._v(_vm._s(user.name))]), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "hover",
        "popper-class": "remove"
      }
    }, [_c('i', {
      staticClass: "el-icon-more right",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.deleteInvite(user.name);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])], 1);
  })], 2)]) : _vm._e(), _vm.selectModule === 3 ? _c('div', {
    staticClass: "passCodeBox"
  }, [_c('div', {
    staticClass: "moduleTitle"
  }, [_vm._v(_vm._s(_vm.$t('invite.passCode')))]), _c('div', {
    staticClass: "passContent",
    class: {
      noMarginRIght: _vm.editPass
    }
  }, [_c('svg', {
    staticClass: "m_r_20 icon-passcode",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-passcode"
    }
  })]), _c('el-input', {
    class: {
      onFocus: _vm.editPass,
      onFocusError: _vm.showErrorPassCode
    },
    attrs: {
      "maxlength": 6
    },
    on: {
      "input": _vm.judgePassCode
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.modifyPassWord('byEnter');
      }
    },
    model: {
      value: _vm.passCodeVal,
      callback: function ($$v) {
        _vm.passCodeVal = $$v;
      },
      expression: "passCodeVal"
    }
  }), _vm.editPass ? _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.passCodeVal,
      expression: "passCodeVal",
      arg: "copy"
    }],
    staticClass: "copy",
    class: {
      saves: _vm.editPass
    },
    on: {
      "click": function ($event) {
        return _vm.modifyPassWord('byEnter');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invite.saveInvite')) + " ")]) : _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.passCodeVal,
      expression: "passCodeVal",
      arg: "copy"
    }],
    staticClass: "copy",
    class: {
      saves: _vm.editPass
    },
    on: {
      "click": _vm.onCopy
    }
  }, [_vm._v(_vm._s(_vm.$t('invite.copyPassCode')) + " ")])], 1), _vm.showErrorPassCode ? _c('div', {
    staticClass: "redColor passwordText"
  }, [_vm._v(_vm._s(_vm.$t('invite.passWordText')))]) : _vm._e()]) : _vm._e(), _vm.$route.name === 'intercom' ? _c('el-divider', {
    staticClass: "accountBoxSlider"
  }) : _vm._e(), _vm.$route.name === 'intercom' ? _c('div', {
    staticClass: "accountBox"
  }, [_c('div', {
    staticClass: "accountHead"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('invite.accountAssociation')))]), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.$t('invite.accountAssociationText')))])]), _c('div', {
    staticClass: "accountContent scrollbar"
  }, _vm._l(_vm.State.stationList, function (item) {
    return _c('div', {
      key: item.rtilCode,
      staticClass: "stationLi"
    }, [_c('div', {
      staticClass: "stationName"
    }, [_vm._v(_vm._s(item.nickName || _vm.nickNameMap[item.rtilCode]))]), _c('span', {
      staticClass: "divider"
    }, [_vm._v("-")]), _c('div', [_c('el-select', {
      attrs: {
        "filterable": "",
        "remote": "",
        "reserve-keyword": "",
        "no-data-text": "No Data",
        "placeholder": "Please select",
        "popper-class": "modelSelect",
        "remote-method": val => {
          _vm.getCanBindEmail(item, val);
        }
      },
      on: {
        "change": function ($event) {
          return _vm.saveBindEmail(item);
        }
      },
      model: {
        value: item.email,
        callback: function ($$v) {
          _vm.$set(item, "email", $$v);
        },
        expression: "item.email"
      }
    }, _vm._l(item.emailList, function (email, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": email,
          "value": email
        }
      });
    }), 1), _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.$t('invite.unBind'),
        "placement": "top-start"
      }
    }, [_c('i', {
      staticClass: "pointer iconfont icon-24gl-unlock",
      on: {
        "click": function ($event) {
          return _vm.cancelBindEmail(item);
        }
      }
    })])], 1)]);
  }), 0)]) : _vm._e()], 1), _c('TipsDailog', {
    staticClass: "collaborate",
    attrs: {
      "info": _vm.collaborateInfo,
      "width": "640px"
    },
    on: {
      "open": _vm.getInvitedList,
      "close": _vm.closeCollaborate
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.getInvitedList
    },
    model: {
      value: _vm.selectType,
      callback: function ($$v) {
        _vm.selectType = $$v;
      },
      expression: "selectType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('personalInfo.inviteCollaborators'),
      "name": "invitedOther"
    }
  }, [_c('div', {
    staticClass: "inviteBox"
  }, [_c('div', {
    staticClass: "userListBox"
  }, [_c('i', {
    staticClass: "el-icon-user-solid m_r_20"
  }), _c('el-input', {
    ref: "emailInput",
    class: {
      redBorder: _vm.showErrorEmailText
    },
    attrs: {
      "placeholder": _vm.$t('invite.invitePlaceholder'),
      "clearable": ""
    },
    on: {
      "input": _vm.checkInputText
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.saveCollaborate.apply(null, arguments);
      }
    },
    model: {
      value: _vm.collaborateSearchName,
      callback: function ($$v) {
        _vm.collaborateSearchName = $$v;
      },
      expression: "collaborateSearchName"
    }
  }), _c('el-button', {
    on: {
      "click": _vm.saveCollaborate
    }
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.adds')))])], 1), _vm.showErrorEmailText ? _c('div', {
    staticClass: "redColor emailWarn"
  }, [_vm._v("* " + _vm._s(_vm.$t('invite.emailCorrectly')))]) : _vm._e(), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.collaborateScroll,
      expression: "collaborateScroll"
    }],
    staticClass: "hadInviteList scrollbar gray"
  }, [_vm._l(_vm.willInviteCollaborate, function (user, index) {
    return _c('div', {
      key: user.name,
      staticClass: "li"
    }, [_c('span', {
      staticClass: "firstName",
      class: user.color
    }, [_vm._v(_vm._s(user.name ? user.name.slice(0, 1) : ''))]), _c('span', {
      staticClass: "emailContent"
    }, [_vm._v(_vm._s(user.name))]), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "hover",
        "popper-class": "remove"
      }
    }, [_c('i', {
      staticClass: "el-icon-more right",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.removeCollaborateInvite(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])], 1);
  }), _vm.willInviteCollaborate.length ? _c('el-divider') : _vm._e(), _vm._l(_vm.hadInviteCollaborate, function (user, index) {
    return _c('div', {
      key: user.collaborateEmail,
      staticClass: "li"
    }, [_c('span', {
      staticClass: "firstName",
      class: user.color
    }, [_vm._v(_vm._s(user.collaborateEmail ? user.collaborateEmail.slice(0, 1) : ''))]), _c('span', {
      staticClass: "emailContent",
      class: {
        declined: user.status === 2
      }
    }, [_vm._v(_vm._s(user.collaborateEmail))]), _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.$t('personalInfo.pending'),
        "placement": "top-start"
      }
    }, [user.status === 0 ? _c('span', {
      staticClass: "right",
      staticStyle: {
        "margin-left": "15px",
        "color": "#909090"
      }
    }, [_vm._v(_vm._s(_vm.$t("personalInfo.inviting")))]) : _vm._e()]), user.status === 2 ? _c('span', {
      staticClass: "right",
      staticStyle: {
        "margin-left": "15px",
        "color": "#909090"
      }
    }, [_vm._v(_vm._s(_vm.$t("personalInfo.declined")))]) : _vm._e(), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "hover",
        "popper-class": "remove"
      }
    }, [_c('i', {
      staticClass: "el-icon-more right",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.deleteCollaborateInvite(user.collaborateUserId, index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])], 1);
  })], 2)])]), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('personalInfo.receivedInvites'),
      "name": "invitedByOther"
    }
  }, [_c('el-table', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.receiverCollaborateScroll,
      expression: "receiverCollaborateScroll"
    }],
    staticClass: "invitedMe",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.invitedMeList,
      "default-sort": {
        prop: 'date',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userEmail",
      "label": "",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "participant firstName",
          class: scope.row.color
        }, [_vm._v(_vm._s(scope.row.userEmail ? scope.row.userEmail.slice(0, 1) : ''))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "userEmail",
      "label": _vm.$t('personalInfo.applicant'),
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "email",
          class: {
            decline: scope.row.status == '2'
          },
          attrs: {
            "title": scope.row.userEmail
          }
        }, [_vm._v(_vm._s(scope.row.userEmail))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "createTime",
      "width": "160",
      "label": _vm.$t('personalInfo.inviteationTime')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', [_vm._v(_vm._s(_vm.showInvitedTime(scope.row.createTime)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "width": "120",
      "label": _vm.$t('personalInfo.Permission')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', {
          class: {
            pedding: scope.row.status == '0'
          }
        }, [_vm._v(_vm._s(_vm.returnText(scope.row)))]), _c('el-select', {
          attrs: {
            "popper-class": "permission"
          },
          on: {
            "change": result => {
              _vm.controlPermission(result, scope.row);
            }
          },
          model: {
            value: scope.row.select,
            callback: function ($$v) {
              _vm.$set(scope.row, "select", $$v);
            },
            expression: "scope.row.select"
          }
        }, _vm._l(_vm.options, function (item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": _vm.$t(`personalInfo.${item.label}`),
              "value": item.value
            }
          });
        }), 1)];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "bottom-start",
            "width": "200",
            "trigger": "hover",
            "popper-class": "remove"
          }
        }, [_c('i', {
          staticClass: "el-icon-more right pointer",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }), _c('span', {
          staticClass: "pointer",
          on: {
            "click": function ($event) {
              return _vm.deleteCollaborateByOtherInvite(scope.row);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])];
      }
    }])
  })], 1)], 1)], 1)], 1), _c('TipsDailog', {
    staticClass: "receivedCohost",
    attrs: {
      "info": _vm.receivedCohost,
      "width": "820px"
    },
    on: {
      "open": _vm.getReceiverCoHostList,
      "close": _vm.closeReceivedCohost
    }
  }, [_c('el-table', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.receiverCohostScroll,
      expression: "receiverCohostScroll"
    }],
    staticClass: "invitedMe",
    staticStyle: {
      "width": "100%",
      "margin-top": "-18px"
    },
    attrs: {
      "data": _vm.invitedMeList,
      "default-sort": {
        prop: 'date',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userEmail",
      "label": "",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "participant firstName",
          class: scope.row.color
        }, [_vm._v(_vm._s(scope.row.userEmail ? scope.row.userEmail.slice(0, 1) : ''))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "userEmail",
      "label": _vm.$t('personalInfo.applicant'),
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "email",
          class: {
            decline: scope.row.status == '2'
          },
          attrs: {
            "title": scope.row.userEmail
          }
        }, [_vm._v(_vm._s(scope.row.userEmail))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "partyName",
      "label": _vm.$t('personalInfo.partyName'),
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "email",
          class: {
            decline: scope.row.status == '2'
          },
          attrs: {
            "title": scope.row.userEmail
          }
        }, [_vm._v(_vm._s(scope.row.partyName ? scope.row.partyName : scope.row.partyCode))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "createTime",
      "width": "160",
      "label": _vm.$t('personalInfo.inviteationTime')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', [_vm._v(_vm._s(_vm.showInvitedTime(scope.row.createTime)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "width": "120",
      "label": _vm.$t('personalInfo.Permission')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', {
          class: {
            pedding: scope.row.status == '0'
          }
        }, [_vm._v(_vm._s(_vm.returnText(scope.row)))]), _c('el-select', {
          attrs: {
            "popper-class": "permission"
          },
          on: {
            "change": result => {
              _vm.controlPermission(result, scope.row);
            }
          },
          model: {
            value: scope.row.select,
            callback: function ($$v) {
              _vm.$set(scope.row, "select", $$v);
            },
            expression: "scope.row.select"
          }
        }, _vm._l(_vm.options, function (item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": _vm.$t(`personalInfo.${item.label}`),
              "value": item.value
            }
          });
        }), 1)];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "bottom-start",
            "width": "200",
            "trigger": "hover",
            "popper-class": "remove"
          }
        }, [_c('i', {
          staticClass: "el-icon-more right pointer",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }), _c('span', {
          staticClass: "pointer",
          on: {
            "click": function ($event) {
              return _vm.deleteCollaborateByOtherInvite(scope.row);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])];
      }
    }])
  })], 1)], 1), _c('TipsDailog', {
    staticClass: "shareFailedBox",
    attrs: {
      "info": _vm.showShareFail,
      "width": "650px"
    }
  }, [_c('p', {
    staticClass: "shareFailedBoxHead"
  }, [_vm._v(_vm._s(_vm.$t('common.shareFailHead')))]), _c('p', {
    staticClass: "shareFailedBoxContent"
  }, [_vm._v(_vm._s(_vm.$t('common.shareFailText1')))]), _c('p', {
    staticClass: "shareFailedBoxContent"
  }, [_vm._v(_vm._s(_vm.$t('common.shareFailText2')))]), _c('p', {
    staticClass: "shareFailedBoxContent"
  }, [_vm._v(_vm._s(_vm.$t('common.shareFailText3')))]), _c('p', {
    staticClass: "shareFailedBoxContent"
  }, [_vm._v(_vm._s(_vm.$t('common.shareFailText4')))]), _c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/mac-screen-recording-privacy.png"
    }
  })]), _c('NewAttendUser', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "is-local",
    attrs: {
      "title": "Me",
      "userInfo": _vm.joinUserInfo
    }
  }, [_c('div', {
    staticClass: "localVideo",
    attrs: {
      "id": "local_stream1"
    }
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };